import checkObjectType from '../_helpers/checkobjecttype.js';
import defs from '../_core/defs.js';
import getNodes from '../bindnode/_getnodes.js';
import removeTreeListener from '../off/_removetreelistener.js';
import forEach from '../_helpers/foreach.js';
import forOwn from '../_helpers/forown.js';
import assign from '../_helpers/assign.js';
import removeBinding from './_removebinding.js';
import toArray from '../_helpers/toarray.js';
import deepBindings from '../bindnode/_deepbindings.js';
import getProp from '../_helpers/getprop.js';
// removes the tree listeners of deep bindings ("a.b.c") for given key and nodes (all nodes when null)
function removeDeepBindings(object, key, $nodes) {
  var objectDeepBindings = deepBindings.get(object);
  if (!objectDeepBindings) {
    return;
  }
  var removedNodes = $nodes ? toArray($nodes) : null;
  var retain = [];
  forEach(objectDeepBindings, function (deepBinding) {
    if (deepBinding.key === key) {
      if (removedNodes) {
        deepBinding.$nodes = toArray(deepBinding.$nodes).filter(function (node) {
          return removedNodes.indexOf(node) === -1;
        });
      }
      if (!removedNodes || !deepBinding.$nodes.length) {
        removeTreeListener(object, deepBinding.deepPath.slice(0, -1), deepBinding.bindingSwitcher);
        return;
      }
    }
    retain.push(deepBinding);
  });
  if (retain.length) {
    deepBindings.set(object, retain);
  } else {
    deepBindings.delete(object);
  }
}
export default function unbindNode(object, key, node, eventOptions) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    eventOptions = node;
    node = key;
    key = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'unbindNode');
  }
  if (Array.isArray(key)) {
    if (typeof key[0] === 'string') {
      /*
       * accept array of keys
       * this.unbindNode(['a', 'b', 'c'], node)
       */
      forEach(key, function (itemKey) {
        return unbindNode(object, itemKey, node, eventOptions);
      });
    } else {
      /*
       * acept array of objects
       * this.unbindNode([{ key, node, binder, event }], { silent: true });
       */
      forEach(key, function (_ref) {
        var itemKey = _ref.key,
          itemNode = _ref.node,
          itemEventOptions = _ref.event;
        var commonEventOptions = node;
        var mergedEventOptions = {};
        if (commonEventOptions) {
          // extend event object by "global" event
          assign(mergedEventOptions, commonEventOptions);
        }
        if (itemEventOptions) {
          // extend event object by "local" event ("event" key of an object)
          assign(mergedEventOptions, itemEventOptions);
        }
        unbindNode(object, itemKey, itemNode, mergedEventOptions);
      });
    }
    return object;
  }
  if (key && typeof key === 'object') {
    forOwn(key, function (keyObjValue, keyObjKey) {
      if (!keyObjValue) {
        unbindNode(object, keyObjKey, null, node);
      } else if (keyObjValue.constructor === Object && 'node' in keyObjValue) {
        // this.unbindNode({ key: { node: $(), binder } ) }, { silent: true });
        unbindNode(object, keyObjKey, keyObjValue.node, node);
      } else if (keyObjValue.constructor === Array && keyObjValue.length && keyObjValue[0].constructor === Object && 'node' in keyObjValue[0]) {
        // this.unbindNode({ key: [{ node: $(), binder }] ) }, { silent: true });
        forEach(keyObjValue, function (keyObjValueItem) {
          unbindNode(object, keyObjKey, keyObjValueItem.node, node);
        });
      } else {
        // this.unbindNode({ key: $() }, { silent: true });
        unbindNode(object, keyObjKey, keyObjValue, node);
      }
    });
    return object;
  }
  eventOptions = eventOptions || {};
  var _eventOptions = eventOptions,
    deep = _eventOptions.deep,
    exactKey = _eventOptions.exactKey;
  var def = defs.get(object);
  if (!def) {
    return object;
  }
  var props = def.props;
  // allow to pass null or undefined as key
  // if passed then remove bindings of all keys for given object
  if (key === null || typeof key === 'undefined') {
    // a prop's key is exact: "a.b" made with exactKey is a key with a dot, not a path
    forOwn(props, function (_, propsKey) {
      unbindNode(object, propsKey, null, assign({}, eventOptions, {
        exactKey: true
      }));
    });
    var objectDeepBindings = deepBindings.get(object);
    if (objectDeepBindings) {
      forEach(objectDeepBindings, function (deepBinding) {
        unbindNode(object, deepBinding.key, null, eventOptions);
      });
    }
    return object;
  }
  // remove delegated binding
  if (deep !== false && !exactKey) {
    var deepPath = key.split('.');
    var deepPathLength = deepPath.length;
    if (deepPathLength > 1) {
      var _deepBindings$get;
      var $nodes = node ? getNodes(object, node) : null;
      var target = object;
      for (var i = 0; i < deepPathLength - 1; i++) {
        target = getProp(target, deepPath[i]);
        // the branch is gone, so there is no binding to remove from its end
        if (!target || typeof target !== 'object') {
          break;
        }
      }
      // without a node, only the nodes of this deep binding: a binding made on the target directly stays
      var ownNodes = $nodes != null ? $nodes : ((_deepBindings$get = deepBindings.get(object)) != null ? _deepBindings$get : []).filter(function (deepBinding) {
        return deepBinding.key === key;
      }).reduce(function (nodes, deepBinding) {
        return nodes.concat(toArray(deepBinding.$nodes));
      }, []);
      removeDeepBindings(object, key, $nodes);
      if (target && typeof target === 'object' && ownNodes.length) {
        unbindNode(target, deepPath[deepPathLength - 1], ownNodes, eventOptions);
      }
      return object;
    }
  }
  var propDef = props[key];
  // when no propdef do nothing
  if (!propDef) {
    return object;
  }
  var bindings = propDef.bindings;
  // if the property doesn't have any bindings do nothing
  if (!bindings) {
    return object;
  }
  // no node removes every binding of the key
  var removedNodes = node ? toArray(getNodes(object, node)) : null;
  var removedBindings = [];
  var retainBindings = [];
  var retainNodes = [];
  forEach(bindings, function (binding) {
    if (!removedNodes || removedNodes.indexOf(binding.node) !== -1) {
      removedBindings.push(binding);
    } else {
      retainBindings.push(binding);
      if (retainNodes.indexOf(binding.node) === -1) {
        retainNodes.push(binding.node);
      }
    }
  });
  // update nodes and $nodes for Matreshka instance
  if (object.isMatreshka) {
    if (retainNodes.length) {
      object.nodes[key] = retainNodes[0];
      object.$nodes[key] = retainNodes;
    } else {
      delete object.nodes[key];
      delete object.$nodes[key];
    }
  }
  propDef.bindings = retainBindings.length ? retainBindings : null;
  // the state is updated first: an unbind handler may bind the key again
  forEach(removedBindings, function (binding) {
    removeBinding({
      object: object,
      key: key,
      eventOptions: eventOptions,
      binding: binding
    });
  });
  return object;
}